export default __webpack_public_path__ + "static/media/not-sure-whats-wrong-car.53a3cd12.svg";